<template>
  <section class="selution">
    <div class="container">
      <!-- 标题 -->
      <div class="home_title">
        <div class="left">
          <h1><i>S</i>OLUTION</h1>
          <!-- <p>我们为您提供专业智能工厂解决方案</p> -->
        </div>
        <router-link class="more iconfont icon-jiantou"
          :to="{ name: 'Solution', params: { id: list[0]?.id } }">MORE</router-link>
      </div>
      <!-- list -->
      <div class="list">
        <div v-for="item in list" :key="item.id" class="item">
          <h3>{{ item.title }}</h3>
          <p class="dh_text2">
            {{ item.remark }}
          </p>
          <router-link class="more iconfont icon-jiantou"
            :to="{ name: 'Solution', params: { id: item.id } }">MORE</router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.selution {
  background-image: url(../../assets/image/selutioin_bg.png);
  padding: 100px 0;

  .home_title {
    color: #fff;
  }

  .list {
    margin-top: 50px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    border-radius: 15px;
    overflow: hidden;

    .item {
      background: #ffffffcc;
      padding: 70px 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      transition: all 0.3s;

      h3 {
        font-size: 22px;
        white-space: nowrap;
      }

      p {
        font-size: 14px;
        text-align: center;
        color: #666;
        line-height: 2;
        margin: 25px auto;
      }

      .more {
        color: #333;

        &::after {
          opacity: 0;
        }
      }

      &:hover {
        background: transparent;

        h3 {
          color: #fff;
        }

        p {
          color: #fff;
        }

        .more {
          color: #fff;

          &::after {
            opacity: 1;
          }
        }
      }
    }
  }
}

@media (max-width: 1250px) {
  .selution {
    .list {
      .item {
        padding: 50px;
      }
    }
  }
}

@media (max-width: 900px) {
  .selution {
    .list {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

@media (max-width: 600px) {
  .selution {
    padding: 50px 0 100px;

    .list {
      grid-template-columns: repeat(1, 1fr);
    }
  }
}
</style>